import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import StudyBotNavbar from '../components/Navbar';
import '../styles/AboutPage.css';

function AboutPage() {
  return (
    <div>
      <StudyBotNavbar />
      <Container className="about-page">
        <Row className="justify-content-center">
          <Col>
            <Card className="about-card">
              <Card.Body>
                <Card.Title className="text-center mb-4">About StudyBot</Card.Title>
                <Card.Text>
                  StudyBot is an innovative AI-powered educational platform designed to revolutionize 
                  the way students learn and interact with educational content. Our mission is to 
                  provide personalized, adaptive learning experiences across multiple subjects, 
                  standards, and languages.
                </Card.Text>
                <Card.Text>
                  Key Features:
                  <ul>
                    <li>AI-Powered Intelligent Tutoring</li>
                    <li>Customizable Learning Settings</li>
                    <li>Multi-Language Support</li>
                    <li>Adaptive Learning Methodologies</li>
                  </ul>
                </Card.Text>
                <Card.Text>
                  Powered by Google's Gemini AI, StudyBot provides an interactive, 
                  intelligent learning companion that adapts to your unique learning needs.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AboutPage;
